import { makeApi } from "@zodios/core";
import { z } from "zod";

import { simpleCompanyDtoSchema } from "@/types/backoffice/dto/company/simple-company-dto.ts";

export const backofficeCompanyApi = makeApi([
  {
    method: "get",
    path: "/network-manager",
    response: z.array(simpleCompanyDtoSchema),
    alias: "findNetworkManagers",
    parameters: [
      {
        type: "Query",
        name: "insee",
        schema: z.string().nullish(),
      },
    ],
  },
  {
    method: "get",
    path: "/network-manager/:siteId",
    response: z.array(simpleCompanyDtoSchema),
    alias: "guessNetworkManagers",
    parameters: [
      {
        type: "Query",
        name: "insee",
        schema: z.string().nullish(),
      },
      {
        type: "Path",
        name: "siteId",
        schema: z.number().nullish(),
      },
    ],
  },
]);
